module.exports = function isString(x) {
  return typeof x === 'string';
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isString.js
// module id = 777
// module chunks = 0